export const arrayToObject = (array, keyField) => {
  let newObj = array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});

  return newObj;
};
